export const MODULO_COBROS = "CobrosSuscripciones";

export const normalizarTexto = (texto = "") =>
  String(texto)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

export const leerStorageJSON = (clave) => {
  try {
    const valor = localStorage.getItem(clave);
    return valor ? JSON.parse(valor) : null;
  } catch (error) {
    console.error(`No se pudo leer ${clave}:`, error);
    return null;
  }
};

export const obtenerUsuarioStorage = () =>
  leerStorageJSON("usuario") ||
  leerStorageJSON("user") ||
  leerStorageJSON("usuarios") ||
  {};

export const obtenerRolNombre = () => {
  const usuario = obtenerUsuarioStorage();
  const rol =
    usuario?.rolObjectId?.nombreRol ||
    usuario?.rol?.nombreRol ||
    usuario?.rol?.nombre ||
    usuario?.rol ||
    usuario?.role ||
    usuario?.tipoUsuario ||
    usuario?.nombreRol ||
    usuario?.usuario?.rolObjectId?.nombreRol ||
    usuario?.usuario?.rol?.nombreRol ||
    usuario?.usuario?.rol?.nombre ||
    usuario?.usuario?.rol ||
    usuario?.user?.rolObjectId?.nombreRol ||
    usuario?.user?.rol?.nombreRol ||
    usuario?.user?.rol?.nombre ||
    usuario?.user?.rol ||
    "";

  return String(rol).trim().toUpperCase();
};

export const esSuperAdmin = () =>
  normalizarTexto(obtenerRolNombre()) === "superadmin";

export const obtenerModulosStorage = () => {
  const permisos = leerStorageJSON("permisos");
  const usuario = obtenerUsuarioStorage();

  const modulos = Array.isArray(permisos)
    ? permisos
    : permisos?.modulos ||
      permisos?.permisos ||
      usuario?.modulos ||
      usuario?.permisos ||
      usuario?.usuario?.modulos ||
      usuario?.usuario?.permisos ||
      usuario?.user?.modulos ||
      usuario?.user?.permisos ||
      [];

  return Array.isArray(modulos) ? modulos : [];
};

export const obtenerModuloPorNombre = (nombreModulo) => {
  const buscado = normalizarTexto(nombreModulo);
  return (
    obtenerModulosStorage().find((modulo) => {
      const nombre =
        modulo?.nombreModulo ||
        modulo?.modulo ||
        modulo?.moduloNombre ||
        modulo?.nombre ||
        modulo?.name ||
        modulo?.moduloObjectId?.nombreModulo ||
        modulo?.moduloObjectId?.nombre ||
        "";
      return normalizarTexto(nombre) === buscado;
    }) || {}
  );
};

export const tienePermiso = (modulo, accion) => {
  if (esSuperAdmin()) return true;

  const accionNormalizada = normalizarTexto(accion);
  const camposPorAccion = {
    leer: ["puedeLeer", "leer", "read", "ver", "listar"],
    crear: ["puedeCrear", "crear", "create", "add", "registrar"],
    actualizar: ["puedeActualizar", "actualizar", "update", "editar", "edit"],
    eliminar: ["puedeEliminar", "eliminar", "delete", "borrar", "remove"],
  };

  const campos = camposPorAccion[accionNormalizada] || [accion];
  const directo = campos.some(
    (campo) =>
      modulo?.[campo] === true ||
      modulo?.acciones?.[campo] === true ||
      modulo?.permisos?.[campo] === true
  );

  const arreglo = [
    ...(Array.isArray(modulo?.acciones) ? modulo.acciones : []),
    ...(Array.isArray(modulo?.permisos) ? modulo.permisos : []),
    ...(Array.isArray(modulo?.operaciones) ? modulo.operaciones : []),
  ].map(normalizarTexto);

  return directo || campos.some((campo) => arreglo.includes(normalizarTexto(campo)));
};

export const authConfig = () => {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  return { headers: { Authorization: `Bearer ${token}` } };
};

export const obtenerId = (valor) => {
  if (!valor) return "";
  if (typeof valor === "object") return valor._id || "";
  return valor;
};

export const fechaHoyInput = () => {
  const hoy = new Date();
  const offset = hoy.getTimezoneOffset();
  return new Date(hoy.getTime() - offset * 60000).toISOString().split("T")[0];
};

export const toInputDate = (valor) => {
  if (!valor) return "";
  const texto = String(valor);
  if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) return texto;
  const fecha = new Date(valor);
  if (Number.isNaN(fecha.getTime())) return "";
  const offset = fecha.getTimezoneOffset();
  return new Date(fecha.getTime() - offset * 60000).toISOString().split("T")[0];
};

export const formatearFecha = (valor) => {
  if (!valor) return "—";
  const fecha = new Date(valor);
  if (Number.isNaN(fecha.getTime())) return "—";
  return new Intl.DateTimeFormat("es-CO", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(fecha);
};

export const formatearFechaHora = (valor) => {
  if (!valor) return "—";
  const fecha = new Date(valor);
  if (Number.isNaN(fecha.getTime())) return "—";
  return new Intl.DateTimeFormat("es-CO", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(fecha);
};

export const formatearMoneda = (valor, moneda = "COP") => {
  try {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: moneda || "COP",
      maximumFractionDigits: 0,
    }).format(Number(valor || 0));
  } catch {
    return `$ ${Number(valor || 0).toLocaleString("es-CO")}`;
  }
};

export const nombreInstructor = (instructor) => {
  if (!instructor) return "—";
  if (typeof instructor === "string") return instructor;
  return (
    [
      instructor.nombre1Instructor,
      instructor.nombre2Instructor,
      instructor.apellido1Instructor,
      instructor.apellido2Instructor,
    ]
      .filter(Boolean)
      .join(" ")
      .replace(/\s+/g, " ")
      .trim() || "—"
  );
};

export const nombreOrigen = (origen = "") => {
  const mapa = {
    PAGO: "Suscripción",
    RENOVACION: "Renovación",
    PRUEBA: "Prueba",
    CORTESIA: "Cortesía",
    ADMINISTRADOR: "Administrador",
  };
  const valor = String(origen || "").toUpperCase();
  return mapa[valor] || valor.replaceAll("_", " ") || "—";
};

export const nombreConcepto = (concepto = "") => {
  const valor = String(concepto || "").toUpperCase();
  return valor === "RENOVACION" ? "Renovación" : valor === "SUSCRIPCION" ? "Suscripción" : valor || "—";
};

export const badgeEstado = (estado = "") => {
  const valor = String(estado || "").toUpperCase();
  const clases = {
    PENDIENTE_PAGO: "text-bg-warning",
    PENDIENTE: "text-bg-warning",
    ACTIVA: "text-bg-success",
    POR_VENCER: "text-bg-warning",
    GRACIA: "text-bg-info",
    VENCIDA: "text-bg-danger",
    SUSPENDIDA: "text-bg-danger",
    CANCELADA: "text-bg-secondary",
    APROBADO: "text-bg-success",
    RECHAZADO: "text-bg-danger",
    ANULADO: "text-bg-secondary",
    REEMBOLSADO: "text-bg-info",
  };
  return (
    <span className={`badge rounded-pill ${clases[valor] || "text-bg-secondary"}`}>
      {valor.replaceAll("_", " ") || "—"}
    </span>
  );
};

export const manejarErrorSesion = (error, navigate) => {
  if (error?.response?.status !== 401) return false;
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
  navigate("/", { replace: true });
  return true;
};
